import { render, staticRenderFns } from "./Programare_produse.vue?vue&type=template&id=b3abb0b8&scoped=true"
import script from "./Programare_produse.vue?vue&type=script&lang=js"
export * from "./Programare_produse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3abb0b8",
  null
  
)

export default component.exports